import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Sealing_tiled_roofs_using_an_innovative_method() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>        איטום גגות מרוצפים בשיטה חדשנית</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Sealing_tiled_roofs_using_an_innovative_method">     איטום גגות מרוצפים בשיטה חדשנית</Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page6">
  <div className="container">
    <div className="red-banner">
איטום גגות מרוצפים בשיטה חדשנית (ללא פירוק הריצוף)
    </div>

    <div className="content-row2">


      <div className="text-box">
       <p>  
בנוסף למערכות האיטום הידועות והמוכרות בשוק נוספו בשנים האחרונות מערכות איטום מתקדמות על בסיס סילוקסנים שקופים לאיטום על גגות מרוצפים, משטחי בטון , קירות חיצוניים, חיפויי אבן וכו..          </p>

    <p> 

אבל את המערכות הנ"ל חובה לבצע בצורה קפדנית לפי מפרט הביצוע ולכן יש לבצע את מערכות איטום אלו רק ע"י קבלן איטום ידוע בעל ניסיון וותק שמתמחה בתחום איטומים בגבהים.

</p>

  <h2 className="info-title">  איטומים בגבהים קבלנים ויועצים לעבודות איטום.  





</h2>




      </div>

    </div>





    <ContactSection2/>
<div className="links2">


  <Link to="/Betkal_Casting" className="link-right" >     יציקת בטקל</Link>
  <Link to="/Sealing_the_house_envelope" className="link-left" >   איטום מעטפת הבית     </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


